var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"GoTop"},on:{"click":function($event){return _vm.GoTop()}}},[_c('span',{staticClass:"glyphicon glyphicon-chevron-up"})])
}
var staticRenderFns = []

export { render, staticRenderFns }